import { useState } from "react";
import { Form } from "react-bootstrap";
import { TfiAngleDown, TfiAngleUp } from "react-icons/tfi";

export const InputFieldComponent = ({
  type = "text",
  label = "",
  sufixIcon = null,
  prefixIcon = null,
  handleSufixIconClick = null,
  onChange,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Form.Group>
      {label && (
        <Form.Label className="text-dark fw-semibold">{label}</Form.Label>
      )}
      <div className="position-relative">
        <Form.Control
          required
          {...props}
          placeholder={props.placeholder ?? ""}
          style={{
            paddingRight: type === "password" || sufixIcon ? "3rem" : "",
            paddingLeft: prefixIcon ? "3rem" : "",
          }}
          onChange={onChange}
          type={
            type === "password" ? (showPassword ? "text" : "password") : type
          }
        />
        {type === "password" && (
          <div
            className="position-absolute top-0 end-0 d-flex justify-content-center align-items-center h-100 rounded-2 pe-cursor"
            style={{
              minWidth: "3rem",
            }}
            onClick={togglePassword}
          >
            {showPassword ? <TfiAngleDown /> : <TfiAngleUp />}
          </div>
        )}
        {sufixIcon && (
          <div
            className={`position-absolute top-0 end-0 d-flex justify-content-center align-items-center h-100 rounded-2 ${
              handleSufixIconClick != null ? "pe-cursor" : ""
            }`}
            style={{
              minWidth: "3rem",
            }}
            onClick={handleSufixIconClick || (() => {})}
          >
            {sufixIcon}
          </div>
        )}
        {prefixIcon && (
          <div
            className={`position-absolute top-0 start-0 d-flex justify-content-center align-items-center h-100 rounded-2`}
            style={{
              minWidth: "3rem",
            }}
          >
            {prefixIcon}
          </div>
        )}
      </div>
    </Form.Group>
  );
};
